export const messages = {
  en: {
    contractChangeDetail: {
      contractInfo: 'Contract Information',
      selectContract: 'Select Contract',
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      contractType: 'Contract Type',
      partyA: 'Party A',
      partyB: 'Party B',
      aContacts: 'Party A Contact',
      bContacts: 'Party B Contact',
      aLink: 'Party A Phone',
      bLink: 'Party B Phone',
      operator: 'Operator',
      operatorLink: 'Operator Phone',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      signingTime: 'Signing Time',
      changeRemark: 'Change Remark',
      changeRemarkPlaceholder: 'Required, please fill in the change remark',
      changeRemarkRequired: 'Change remark is required'
    },
    contractChangeMainBody: {
      title: 'Main Body Change',
      contractName: 'Contract Name',
      contractNamePlaceholder: 'Required, please fill in contract name',
      partyA: 'Party A',
      partyAPlaceholder: 'Required, please fill in Party A',
      aContacts: 'Party A Contact',
      aContactsPlaceholder: 'Required, please fill in Party A contact',
      aLink: 'Party A Phone',
      aLinkPlaceholder: 'Required, please fill in Party A phone',
      partyB: 'Party B',
      partyBPlaceholder: 'Required, please fill in Party B',
      bContacts: 'Party B Contact',
      bContactsPlaceholder: 'Required, please fill in Party B contact',
      bLink: 'Party B Phone',
      bLinkPlaceholder: 'Required, please fill in Party B phone'
    },
    contractChangeLease: {
      title: 'Lease Adjustment',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time'
    },
    contractChangeAssets: {
      title: 'Related Rooms',
      room: 'Room',
      owner: 'Owner',
      phone: 'Phone',
      area: 'Area',
      status: 'Status',
      squareMeters: 'Square Meters',
      confirmDelete: 'Are you sure to delete this room?'
    },
    purchaseApprovers: {
      title: 'Approver Information',
      orgName: 'Organization',
      staffName: 'Staff',
      orgPlaceholder: 'Required, please fill in organization',
      staffPlaceholder: 'Required, please select staff',
      staffRequired: 'Staff is required',
      staffNameRequired: 'Staff name is required'
    },
    chooseContract: {
      title: 'Select Contract',
      searchPlaceholder: 'Input contract name',
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      contractType: 'Contract Type',
      partyA: 'Party A',
      partyB: 'Party B',
      signingTime: 'Signing Time'
    }
  },
  zh: {
    contractChangeDetail: {
      contractInfo: '合同信息',
      selectContract: '选择合同',
      contractName: '合同名称',
      contractCode: '合同编号',
      contractType: '合同类型',
      partyA: '甲方',
      partyB: '乙方',
      aContacts: '甲方联系人',
      bContacts: '乙方联系人',
      aLink: '甲方联系电话',
      bLink: '乙方联系电话',
      operator: '经办人',
      operatorLink: '联系电话',
      amount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      signingTime: '签订时间',
      changeRemark: '变更说明',
      changeRemarkPlaceholder: '必填，请填写变更说明',
      changeRemarkRequired: '变更说明不能为空'
    },
    contractChangeMainBody: {
      title: '主体变更',
      contractName: '合同名称',
      contractNamePlaceholder: '必填，请填写合同名称',
      partyA: '甲方',
      partyAPlaceholder: '必填，请填写甲方',
      aContacts: '甲方联系人',
      aContactsPlaceholder: '必填，请填写甲方联系人',
      aLink: '甲方联系电话',
      aLinkPlaceholder: '必填，请填写甲方联系电话',
      partyB: '乙方',
      partyBPlaceholder: '必填，请填写乙方',
      bContacts: '乙方联系人',
      bContactsPlaceholder: '必填，请填写乙方联系人',
      bLink: '乙方联系电话',
      bLinkPlaceholder: '必填，请填写乙方联系电话'
    },
    contractChangeLease: {
      title: '租期调整',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间'
    },
    contractChangeAssets: {
      title: '关联房屋',
      room: '房屋',
      owner: '业主',
      phone: '电话',
      area: '建筑面积',
      status: '房屋状态',
      squareMeters: '平方米',
      confirmDelete: '确定删除该房屋吗？'
    },
    purchaseApprovers: {
      title: '审批人信息',
      orgName: '所属组织',
      staffName: '员工',
      orgPlaceholder: '必填，请填写所属组织',
      staffPlaceholder: '必填，请选择员工',
      staffRequired: '员工不能为空',
      staffNameRequired: '员工名称不能为空'
    },
 
chooseContract: {
      title: '选择合同信息',
      searchPlaceholder: '输入合同信息名称',
      contractName: '合同名称',
      contractCode: '合同编号',
      contractType: '合同类型',
      partyA: '甲方',
      partyB: '乙方',
      signingTime: '签订时间'
    }
  },
  'zh-TW': {
    contractChangeDetail: {
      contractInfo: '合同信息',
      selectContract: '選擇合同',
      contractName: '合同名稱',
      contractCode: '合同編號',
      contractType: '合同類型',
      partyA: '甲方',
      partyB: '乙方',
      aContacts: '甲方聯絡人',
      bContacts: '乙方聯絡人',
      aLink: '甲方聯繫電話',
      bLink: '乙方聯繫電話',
      operator: '經辦人',
      operatorLink: '聯繫電話',
      amount: '合同金額',
      startTime: '開始時間',
      endTime: '結束時間',
      signingTime: '簽訂時間',
      changeRemark: '變更說明',
      changeRemarkPlaceholder: '必填，請填寫變更說明',
      changeRemarkRequired: '變更說明不能為空'
    },
    contractChangeMainBody: {
      title: '主體變更',
      contractName: '合同名稱',
      contractNamePlaceholder: '必填，請填寫合同名稱',
      partyA: '甲方',
      partyAPlaceholder: '必填，請填寫甲方',
      aContacts: '甲方聯絡人',
      aContactsPlaceholder: '必填，請填寫甲方聯絡人',
      aLink: '甲方聯繫電話',
      aLinkPlaceholder: '必填，請填寫甲方聯繫電話',
      partyB: '乙方',
      partyBPlaceholder: '必填，請填寫乙方',
      bContacts: '乙方聯絡人',
      bContactsPlaceholder: '必填，請填寫乙方聯絡人',
      bLink: '乙方聯繫電話',
      bLinkPlaceholder: '必填，請填寫乙方聯繫電話'
    },
    contractChangeLease: {
      title: '租期調整',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請選擇開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請選擇結束時間'
    },
    contractChangeAssets: {
      title: '關聯房屋',
      room: '房屋',
      owner: '業主',
      phone: '電話',
      area: '建築面積',
      status: '房屋狀態',
      squareMeters: '平方米',
      confirmDelete: '確定刪除該房屋嗎？'
    },
    purchaseApprovers: {
      title: '審批人信息',
      orgName: '所屬組織',
      staffName: '員工',
      orgPlaceholder: '必填，請填寫所屬組織',
      staffPlaceholder: '必填，請選擇員工',
      staffRequired: '員工不能為空',
      staffNameRequired: '員工名稱不能為空'
    },
    chooseContract: {
      title: '選擇合同信息',
      searchPlaceholder: '輸入合同信息名稱',
      contractName: '合同名稱',
      contractCode: '合同編號',
      contractType: '合同類型',
      partyA: '甲方',
      partyB: '乙方',
      signingTime: '簽訂時間'
    }
  }
}